import fseDefaultTheme from '../../themes/fse/theme';

export { fseDefaultTheme };
